import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBarIcons from "./TopBarIcons";
import "../css/requisition-app-styles.css";
import PopupModal from "./PopupModal";  
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import LoadingOverlay from "./LoadingOverlay";
import { faWifi } from '@fortawesome/free-solid-svg-icons';


const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const theUserType = localStorage.getItem("userType");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [originalData, setOriginalData] = useState({});
  const [formData, setFormData] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    position: "",
    staffLevel: "",
    supervisorName: "",
    userType: "",
    signature: "",
    displayPicture: "",
    password: "",  
  });
  const [displayPicturePreview, setDisplayPicturePreview] = useState("");
  const [signaturePreview, setSignaturePreview] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  
  const [showModal, setShowModal] = useState(false);

  const     handleModalClose = () => {
    navigate('/view-users'); 
    window.location.reload();
  };

  const getFullImageUrl = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `http://localhost:5259${path}`;
  };
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/${id}`)
      .then(({ data: user }) => {
        const { userName, firstName, lastName, email, phoneNumber,
                position, staffLevel, supervisorName, userType,
                displayPictureFilePath, signatureFilePath } = user;
        console.log("DP path:", displayPictureFilePath);
        console.log("Signature path:", signatureFilePath);
        setOriginalData(user);
        setFormData({ userName, firstName, lastName, email, phoneNumber,
                      position, staffLevel, supervisorName, userType,
                      displayPicture: "", signature: "" });

        setDisplayPicturePreview(getFullImageUrl(displayPictureFilePath));
        setSignaturePreview(getFullImageUrl(signatureFilePath));
      })
      .catch(err => {
        console.error("Failed to load user:", err);
        setErrorMessage("Could not load user data.");
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const field = e.target.name;
    if (!file || !file.type.startsWith("image/")) return alert("Select an image file.");

    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.src = reader.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const MAX = 400;
        let { width, height } = img;
        if (width > height) {
          if (width > MAX) { height *= MAX / width; width = MAX; }
        } else {
          if (height > MAX) { width *= MAX / height; height = MAX; }
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        const dataUrl = canvas.toDataURL("image/jpeg", 0.5);

        if (field === "displayPicture") {
          setDisplayPicturePreview(dataUrl);
        } else {
          setSignaturePreview(dataUrl);
        }
        setFormData(prev => ({ ...prev, [field]: dataUrl }));
      };
    };
    reader.readAsDataURL(file);
  };

  const handlePatch = async (e) => {
    e.preventDefault();

    const updates = {};
    for (const key in formData) {
        if (
            key === "displayPicture" && formData.displayPicture
          ) {
            updates.displayPicture = formData.displayPicture;
          } else if (
            key === "signature" && formData.signature
          ) {
            updates.signature = formData.signature;
        } else if (key === "password" && formData.password.trim() !== "") {
            updates.password = formData.password;
          } else if (
            formData[key] && formData[key] !== originalData[key]
          ) {
            updates[key] = formData[key];
          }
    }

    if (Object.keys(updates).length === 0) {
      alert("No changes detected.");
      return;
    }
    try {
        setIsSubmitting(true);

        try {
            await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/users/${id}`, updates);
            setShowModal(true);
          } catch (err) {
            console.error("Update failed:", err);
            setErrorMessage("Failed to update user.");
          }
    } finally {
        setIsSubmitting(false);
        

    }

    
  };

  return (
    <div id="wrapper">
     <LoadingOverlay isVisible={isSubmitting} />
        
      <Sidebar userType={theUserType} />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <button className="btn btn-link d-md-none rounded-circle mr-3" id="sidebarToggleTop">
              <i className="fa fa-bars"></i>
            </button>
            <ul className="navbar-nav ml-auto"><TopBarIcons /></ul>
          </nav>

          <div className="container-fluid">
            <div className="view-requisition-header">
              <Link to="/users" className="nav-link">
                <i className="fas fa-arrow-left back-button" />
              </Link>
              <h1 className="form-heading h3 mb-4 text-gray-800">Edit User</h1>
            </div>

            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
            {successMessage && <div className="alert alert-success">{successMessage}</div>}

            <form onSubmit={handlePatch} className="reduce-width-div">
              <div className="form-group">
                <label>Display Picture</label>
                <input type="file" name="displayPicture" className="form-control"
                       accept="image/*" onChange={handleFileChange} />
                {displayPicturePreview && (
                  <img src={displayPicturePreview} alt="DP" className="preview-image" />
                )}
              </div>

              <div className="form-group">
                <label>Signature</label>
                <input type="file" name="signature" className="form-control"
                       accept="image/*" onChange={handleFileChange} />
                {signaturePreview && (
                  <img src={signaturePreview} alt="Signature" className="preview-image" />
                )}
              </div>

              <div className="form-group">
                <label>Password</label>
                <input
                    type="password"
                    name="password"
                    className="form-control"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter new password"
                    autoComplete="new-password"
                />
              </div>


              {["firstName","lastName","userName","email","phoneNumber",
                "position","staffLevel","supervisorName"].map(field => (
                <div className="form-group" key={field}>
                  <label>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
                  <input type="text" name={field} className="form-control"
                         value={formData[field]} onChange={handleChange} required />
                </div>
              ))}
              <div className="form-group">
                <label htmlFor="userType">User Type</label>
                <select
                    id="userType"
                    name="userType"
                    className="form-control"
                    value={formData.userType}
                    onChange={handleChange}
                    required
                >
                    <option value="">Select User Type</option>
                    <option value="Requester">Requester</option>
                    <option value="Reviewer">Reviewer</option>
                    <option value="Surrender Reviewer">Surrender Reviewer</option>
                    <option value="Administrator">Administrator</option>
                </select>
                </div>


              <button type="submit" className="btn btn-primary">Apply Changes</button>
            </form>
            <PopupModal
              title="Edited"
              titleStyle = "success-title"
              message="This user has been edited successfully."
              icon={faCheckCircle}
              isVisible={showModal}
              onClose={handleModalClose}
              iconBorder="popup-modal-icon"
            />
          </div>
        </div>

        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright © Farm Concern Internationalal 2025</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default EditUser;
